<template>
    <div :class="['ring-container']" :style="containerStyle">
      <div :class="['ring']" :style="ringStyle"></div>
      <div class="inner-circle" :style="innerCircleStyle"></div>
      <div class="center-text" :style="textStyle">{{ percentage }}%</div>
    </div>
  </template>
  
  <script>
  export default {
    name:'RingProgressIndicator',
    props: {
      percentage: {
        type: Number,
        required: true
      },
      ringColor: {
        type: String,
        default: 'orange'
      },
      size: {
        type: Number,
        default: 150 
      }
    },
    computed: {
      ringStyle() {
        return {
          background: `conic-gradient(${this.ringColor} ${this.percentage}%, #f0f0f0 0)`,
          width: `${this.size}px`,
          height: `${this.size}px`,
        };
      },
      containerStyle() {
        return {
          width: `${this.size}px`,
          height: `${this.size}px`,
        };
      },
      innerCircleStyle() {
        return {
          width: `${this.size * 0.8}px`,
          height: `${this.size * 0.8}px`,
        };
      },
      textStyle() {
        return {
          fontSize: '17px',
          width:'47px',
        };
      }
    }
  };
  </script>
  
  <style scoped>
  .ring-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .ring {
    position: absolute;
    border-radius: 50%;
  }
  
  .inner-circle {
    position: absolute;
    background-color: white;
    border-radius: 50%;
  }
  
  .center-text {
    position: absolute;
    font-weight: bold;
    color: #333;
    text-align: center;
  }
  </style>
  